<app-wrapper>

  <div class="mb-9">
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Рассылка
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <button (click)="send()" [disabled]="form.invalid" class="btn btn-primary">
            <i class="fa-solid fa-paper-plane"></i>&nbsp;Отправить
          </button>
        </div>
      </div>
    </div>
    <div class="row g-5">
      <div class="col-12">
        <form #form="ngForm" class="card p-4">
          <div class="row">
            <div class="col-md-4 col-lg-2">
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input type="text" name="caption" [(ngModel)]="model.caption" maxlength="150"
                    class="form-control" required placeholder="Заголовок">
                    <label>Заголовок</label>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-lg-2">
                <div class="form-check form-switch mb-3">
                  <input class="form-check-input" type="checkbox" name="sendAll"
                    [(ngModel)]="model.sendAll">
                    <label class="form-check-label" for="flexSwitchCheckDefault">Отправить всем</label>
                  </div>
                </div>
                <div class="col-12 mb-4">
                  <div class="form-group">
                    <div class="form-floating mb-3">
                      <textarea [(ngModel)]="model.text" maxlength="1000" name="text"
                      placeholder="Основной текст" rows="5" class="form-control" required></textarea>
                      <label>
                        Основной Текст
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              @if (!model.sendAll) {
                <div>
                  <div class="mb-4">
                    <div class="row g-3">
                      <div class="col-auto">
                        <div class="search-box">
                          <div class="position-relative">
                            <input type="text" class="form-control search-input search"
                              [(ngModel)]="search" name="search" placeholder="Поиск"
                              (keyup.enter)="searchItems()" />
                              <i class="fa-solid fa-search search-box-icon"></i>
                            </div>
                          </div>
                        </div>
                        <div class="col-auto flex-grow-1">
                        </div>
                        <div class="col-auto">
                          Выбранно пользователей:
                          <b>{{model.users.length}}</b>&nbsp;
                          <button class="btn btn-danger" type="button" (click)="clearSelectedList()">Очистить
                          список</button>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="bg-white border-top border-bottom border-200 position-relative top-1">
                        <div class="table-responsive mx-n1 px-1">
                          <table class="table fs--1 mb-0">
                            <thead>
                              <tr>
                                <th style="width: 30%;">Имя пользователя</th>
                                <th style="width: 30%;">Имя</th>
                                <th style="width: 10%;">Роль</th>
                                <th style="width: 20%"></th>
                              </tr>
                            </thead>
                            <tbody class="list">
                              @if (isLoading) {
                                <tr>
                                  <td colspan="10" class="text-center">
                                    <i class="fa-solid fa-spinner fa-spin"></i>
                                  </td>
                                </tr>
                              }
                              @for (item of items; track item; let i = $index) {
                                <tr>
                                  <td>
                                    <a target="_blank" [routerLink]="[ '/users/edit/'+item.id]">
                                      {{ item.userName }}
                                    </a>
                                  </td>
                                  <td>
                                    {{ item.name }}
                                  </td>
                                  <td>
                                    {{ item.role }}
                                  </td>
                                  <td class="text-center">
                                    @if (!isUserAdded(item.id)) {
                                      <button class="btn btn-success"
                                        type="button" (click)="addUser(item.id)"><i
                                      class="fa-solid fa-plus"></i></button>
                                    }
                                    @if (isUserAdded(item.id)) {
                                      <button class="btn btn-danger"
                                        type="button" (click)="removeUser(item.id)"><i
                                      class="fa-solid fa-times"></i></button>
                                    }
                                  </td>
                                </tr>
                              }
                              @if (!isBusy && items.length == 0) {
                                <tr>
                                  <td colspan="10" class="text-center">
                                    Список пуст
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                        <div class="d-flex justify-content-end py-2 pe-0 fs--1">
                          <ul class="pagination pagination-sm mb-0">
                            <li class="page-item" [ngClass]="{'disabled': page === 1}"
                              (click)="getData(page - 1)">
                              <a onclick="return false;" class="page-link" href="#" tabindex="-1">
                                <span aria-hidden="true"><i class="fa-solid fa-chevron-left"></i></span>
                              </a>
                            </li>
                            @for (item of getPages(); track item) {
                              <li class="page-item"
                                [ngClass]="{'active': page === item.page, 'disabled': item.isDisabled}"
                                (click)="getData(item.page)">
                                <a class="page-link" onclick="return false;" href="#">{{ item.label }}</a>
                              </li>
                            }
                            <li class="page-item" [ngClass]="{ 'disabled': !pages || page === pages }"
                              (click)="getData(page + 1)">
                              <a onclick="return false;" class="page-link" href="#">
                                <span aria-hidden="true"><i
                                class="fa-solid fa-chevron-right"></i></span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </form>
            </div>
          </div>
          @if (isBusy) {
            <div class="overlay">
              <i class="fa-solid fa-spinner fa-spin"></i>
            </div>
          }

        </div>
      </app-wrapper>